document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector("[data-shipping-simulator]");
  if (!root) return;

  const PLATFORM = (root.dataset.platform || "").trim(); // "mandae" | "melhor-envio"
  const API_URL = (root.dataset.apiUrl || "").trim();

  const botao = root.querySelector("#btn-calc-frete");
  const inputCep = root.querySelector("#cep-simulator");
  const container = root.querySelector(".listas-de-fretes");
  const erroEl = root.querySelector("#erro-frete");

  // ─── Utilitários comuns ────────────────────────────────────────────────────

  function parseDecimalAttr(v) {
    return Number(String(v || "").trim().replace(",", ".").replace(/[^0-9.-]/g, "")) || 0;
  }

  function parseMoneyText(v) {
    const str = String(v || "").replace(/\u00A0/g, " ").trim();
    if (!str) return 0;
    const cleaned = str.replace(/R\$/gi, "").replace(/\s+/g, "").trim();
    if (!cleaned) return 0;
    if (cleaned.includes(",") && cleaned.includes("."))
      return Number(cleaned.replace(/\./g, "").replace(",", ".").replace(/[^0-9.-]/g, "")) || 0;
    if (cleaned.includes(","))
      return Number(cleaned.replace(",", ".").replace(/[^0-9.-]/g, "")) || 0;
    return Number(cleaned.replace(/[^0-9.-]/g, "")) || 0;
  }

  function formatMoneyBRL(value) {
    return `R$ ${Number(value || 0).toFixed(2).replace(".", ",")}`;
  }

  function isTruthy(value) {
    return String(value || "").toLowerCase() === "true";
  }

  function normalizeCepInput(value) {
    let v = String(value || "").replace(/\D/g, "");
    if (v.length > 8) v = v.slice(0, 8);
    if (v.length > 5) v = `${v.slice(0, 5)}-${v.slice(5)}`;
    return v;
  }

  function getCepDigits() {
    return String(inputCep?.value || "").replace(/\D/g, "");
  }

  function setLoading(isLoading) {
    if (!container) return;
    let ld = container.querySelector(".frete-loading");
    if (isLoading) {
      if (!ld) {
        ld = document.createElement("p");
        ld.className = "frete-loading";
        ld.style.opacity = "0.6";
        ld.textContent = "Carregando fretes...";
        container.appendChild(ld);
      }
    } else if (ld) {
      ld.remove();
    }
  }

  function fetchWithTimeout(resource, options = {}) {
    const timeout = options.timeout ?? 9000;
    return Promise.race([
      fetch(resource, options),
      new Promise((_, reject) => setTimeout(() => reject(new Error("Timeout")), timeout))
    ]);
  }

  function renderFreteItem(nome, prazo, preco) {
    const item = document.createElement("div");
    item.className = "frete-item";
    item.innerHTML = `
      <div class="frete-info">
        <span class="frete-nome">${nome}</span>
        <span class="frete-prazo">${prazo}</span>
      </div>
      <div class="frete-preco">${preco}</div>
    `;
    container.appendChild(item);
  }

  // ─── Plataforma: MANDAE ────────────────────────────────────────────────────

  const mandae = {
    fixedShippingOnlyEl: root.querySelector("[data-fixed-shipping-only]"),
    simulatorDefaultEl: root.querySelector("[data-shipping-simulator-default]"),

    contextRoot:
      root.closest(".conjunto-page") ||
      root.closest(".product") ||
      root.closest("main") ||
      document,

    parseTags(value) {
      return String(value || "").split(",").map(t => t.trim().toLowerCase()).filter(Boolean);
    },

    customerHasSpecialTag() {
      const special = this.parseTags(root.dataset.specialCustomerTags);
      const customer = this.parseTags(root.dataset.customerTags);
      return special.length && customer.length && special.some(t => customer.includes(t));
    },

    getFixedShippingRanges() {
      const ranges = [];
      for (let i = 1; i <= 5; i++) {
        if (!isTruthy(root.getAttribute(`data-fixed-shipping-enable-${i}`))) continue;
        ranges.push({
          from: parseDecimalAttr(root.getAttribute(`data-fixed-shipping-from-${i}`)),
          to: parseDecimalAttr(root.getAttribute(`data-fixed-shipping-to-${i}`)),
          price: parseDecimalAttr(root.getAttribute(`data-fixed-shipping-price-${i}`))
        });
      }
      return ranges.sort((a, b) => a.from - b.from);
    },

    findMatchingRange(total) {
      return this.getFixedShippingRanges().find(r => total >= r.from && (r.to === 0 || total <= r.to)) || null;
    },

    getConjuntoTotal() {
      const fromAttr = () => {
        const inReais = parseDecimalAttr(root.getAttribute("data-product-total"));
        if (inReais > 0) return inReais;
        const inCents = parseDecimalAttr(root.getAttribute("data-product-total-cents"));
        return inCents > 0 ? inCents / 100 : 0;
      };

      const fromMeta = () => {
        const metaEl = this.contextRoot.querySelector('[id^="ConjuntoMeta-"]');
        if (!metaEl) return 0;
        try {
          const meta = JSON.parse(metaEl.textContent.trim());
          const d = parseDecimalAttr(meta?.base_total_discounted);
          const o = parseDecimalAttr(meta?.base_total_original);
          return d > 0 ? d / 100 : o > 0 ? o / 100 : 0;
        } catch (e) { return 0; }
      };

      const fromDomAttrs = () => {
        const attrs = ["data-conjunto-total","data-product-total","data-total-price","data-price-final","data-product-price","data-conjunto-total-discounted","data-conjunto-total-original"];
        for (const attr of attrs) {
          const el = this.contextRoot.querySelector(`[${attr}]`);
          if (!el) continue;
          const v = parseDecimalAttr(el.getAttribute(attr));
          if (v > 0) return v;
          const t = parseMoneyText(el.textContent);
          if (t > 0) return t;
        }
        return 0;
      };

      const fromKnownSelectors = () => {
        const selectors = [
          ".conjunto-price-summary__current",".conjunto-price-summary__original",".conjunto-price-summary__final",
          ".conjunto-total-final",".conjunto-price__final",".price-item--final",
          ".product__info-container .price-item--sale",".product__info-container .price-item--regular",
          ".product .price-item--sale",".product .price-item--regular",
          ".price .price-item--sale",".price .price-item--regular"
        ];
        for (const sel of selectors) {
          const el = this.contextRoot.querySelector(sel);
          if (!el) continue;
          const t = parseMoneyText(el.textContent);
          if (t > 0) return t;
        }
        return 0;
      };

      return fromAttr() || fromMeta() || fromDomAttrs() || fromKnownSelectors();
    },

    shouldUseFixedOnly() {
      if (!isTruthy(root.dataset.fixedShippingEnable)) return false;
      if (!this.customerHasSpecialTag()) return false;
      const total = this.getConjuntoTotal();
      return total > 0 && !!this.findMatchingRange(total);
    },

    renderFixedOnly() {
      const total = this.getConjuntoTotal();
      const range = this.findMatchingRange(total);
      if (!range) return false;

      const prefix = (root.dataset.fixedShippingActivePrefix || "Frete fixo de").trim();
      const suffix = (root.dataset.fixedShippingActiveSuffix || "liberado para seu pedido.").trim();

      this.fixedShippingOnlyEl.innerHTML = `
        <div class="fixed-shipping-only__text">
          <span>${prefix}</span>
          <span class="fixed-shipping-only__price">${formatMoneyBRL(range.price)}</span>
          <span>${suffix}</span>
        </div>
      `;
      this.fixedShippingOnlyEl.hidden = false;

      if (this.simulatorDefaultEl) {
        this.simulatorDefaultEl.style.display = "none";
        this.simulatorDefaultEl.hidden = true;
      }
      return true;
    },

    hideFixedOnly() {
      if (this.fixedShippingOnlyEl) {
        this.fixedShippingOnlyEl.hidden = true;
        this.fixedShippingOnlyEl.innerHTML = "";
      }
      if (this.simulatorDefaultEl) {
        this.simulatorDefaultEl.style.display = "";
        this.simulatorDefaultEl.hidden = false;
      }
    },

    refreshMode() {
      if (this.shouldUseFixedOnly()) return this.renderFixedOnly();
      this.hideFixedOnly();
      return false;
    },

    getItemPayload() {
      const el = document.getElementById("mande-item");
      if (!el) return null;
      const w = parseDecimalAttr(el.dataset.weightGrams || el.dataset.baseWeightGrams);
      const wi = parseDecimalAttr(el.dataset.widthCm || el.dataset.baseWidthCm);
      const h = parseDecimalAttr(el.dataset.heightCm || el.dataset.baseHeightCm);
      const l = parseDecimalAttr(el.dataset.lengthCm || el.dataset.baseLengthCm);
      const qty = parseDecimalAttr(el.dataset.qty) || 1;
      const declaredValue = parseDecimalAttr(el.dataset.declaredValue) || 0;
      if (!w || !wi || !h || !l) return null;
      return { applyInsurance: false, items: [{ weight: w / 1000, height: h, width: wi, length: l, quantity: qty, declaredValue }] };
    },

    renderResults(rates) {
      container.innerHTML = "";
      const list = Array.isArray(rates) ? rates : [];
      if (!list.length) {
        erroEl.textContent = "Nenhuma opção de frete disponível para este CEP.";
        return;
      }
      list.forEach(s => {
        const price = Number(s?.price);
        const days = Number(s?.deliveryTime);
        const nome = `${s?.carrier || ""} ${s?.service || ""}`.trim() || "Entrega";
        renderFreteItem(
          nome,
          Number.isFinite(days) ? `${days} dia${days === 1 ? "" : "s"} úteis` : "",
          Number.isFinite(price) ? `R$ ${price.toFixed(2).replace(".", ",")}` : "-"
        );
      });
    },

    async calcular() {
      if (this.refreshMode()) return;

      const cepDigits = getCepDigits();
      const payload = this.getItemPayload();

      erroEl.textContent = "";
      container.innerHTML = "";

      if (!API_URL) { erroEl.textContent = "API não configurada."; return; }
      if (cepDigits.length !== 8 && cepDigits.length !== 5) { erroEl.textContent = "Preencha o CEP corretamente."; return; }
      if (!payload) { erroEl.textContent = "Dimensões/peso do produto não encontrados."; return; }

      setLoading(true);
      try {
        const res = await fetchWithTimeout(API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cep: cepDigits, payload }),
          timeout: 12000
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        this.renderResults(data?.rates || []);
      } catch (e) {
        erroEl.textContent = "Erro ao calcular frete. Tente novamente.";
      } finally {
        setLoading(false);
      }
    }
  };

  // ─── Plataforma: MELHOR ENVIO ──────────────────────────────────────────────

  const melhorEnvio = {
    ENABLE_FREE: String(root.dataset.enableFree) === "true",
    ENABLE_PICKUP: String(root.dataset.enablePickup) === "true",
    ENABLE_FIXED: String(root.dataset.enableFixed) === "true",
    FIXED_NE_PE_PRICE: parseDecimalAttr(root.dataset.fixedNePePrice || "14.90") || 14.90,
    FIXED_SSCO_PRICE: parseDecimalAttr(root.dataset.fixedSscoPrice || "19.90") || 19.90,
    FROM_CEP: (root.dataset.fromPostalCode || "").replace(/\D/g, ""),

    getItemDimensions() {
      const el = document.getElementById("mande-item");
      if (!el) return null;
      const weight = parseDecimalAttr(el.dataset.weightGrams || el.dataset.baseWeightGrams);
      const width  = parseDecimalAttr(el.dataset.widthCm  || el.dataset.baseWidthCm);
      const height = parseDecimalAttr(el.dataset.heightCm || el.dataset.baseHeightCm);
      const length = parseDecimalAttr(el.dataset.lengthCm || el.dataset.baseLengthCm);
      const insurance_value = parseDecimalAttr(el.dataset.declaredValue) || 0;
      if (!weight || !width || !height || !length) return null;
      return { weight: weight / 1000, width, height, length, insurance_value };
    },

    async requestCotacao(cepDigits) {
      const dims = this.getItemDimensions();
      if (!dims) return [];
      const res = await fetchWithTimeout(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ from_postal_code: this.FROM_CEP, to_postal_code: cepDigits, ...dims }),
        timeout: 12000
      });
      if (!res.ok) throw new Error("HTTP " + res.status);
      const d = await res.json();
      return Array.isArray(d) ? d : [];
    },

    renderPickup() {
      renderFreteItem("Retirada na Valentim | Caruaru - PE", "Pronto em até 12h úteis após o pedido", "Grátis");
    },

    renderFreeShipping() {
      const item = document.createElement("div");
      item.className = "frete-item";
      item.innerHTML = `
        <div class="frete-info">
          <span class="frete-nome">Frete grátis para todo o Brasil
            <a href="https://ially.com.br/pages/politica-de-frete-e-entrega" style="color:inherit;text-decoration:underline;text-decoration-color:rgba(0,0,0,0.15);text-underline-offset:2px;font-weight:400;font-size:0.6rem;"> *leia os termos e condições</a>
          </span>
        </div>
        <div class="frete-preco">Grátis</div>
      `;
      container.appendChild(item);
    },

    renderFixedCard(label, preco, obs) {
      renderFreteItem(label, obs || "", `R$ ${Number(preco).toFixed(2).replace(".", ",")}`);
    },

    slugCity(s) { return (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, " ").trim(); },

    isSSCO(uf) { return ["PR","SC","RS","SP","RJ","ES","MG","DF","GO","MT","MS"].includes(uf); },

    NE_ALLOWED: [
      { uf: "AL", city: "Maceió" }, { uf: "CE", city: "Fortaleza" }, { uf: "MA", city: "São Luís" },
      { uf: "PB", city: "João Pessoa" }, { uf: "RN", city: "Natal" }, { uf: "PI", city: "Teresina" },
      { uf: "SE", city: "Aracaju" }, { uf: "PB", city: "Campina Grande" }
    ],

    isNEAllowed(uf, city) {
      return this.NE_ALLOWED.some(i => i.uf === uf && this.slugCity(i.city) === this.slugCity(city));
    },

    async lookupCep(cepDigits) {
      try {
        const r = await fetchWithTimeout(`https://viacep.com.br/ws/${cepDigits}/json/`, { timeout: 9000 });
        const d = await r.json();
        if (d && !d.erro) return { uf: String(d.uf || "").toUpperCase(), city: String(d.localidade || "") };
      } catch (_) {}
      const r2 = await fetchWithTimeout(`https://brasilapi.com.br/api/cep/v2/${cepDigits}`, { timeout: 7000 });
      const d2 = await r2.json();
      return { uf: String(d2.state || "").toUpperCase(), city: String(d2.city || "") };
    },

    async determineFixed(cepDigits) {
      if (!this.ENABLE_FIXED) return [];
      try {
        const { uf, city } = await this.lookupCep(cepDigits);
        if (uf === "PE")
          return [{ label: "Frete Fixo - Pernambuco", price: this.FIXED_NE_PE_PRICE, obs: "Frete fixo para Pernambuco" }];
        if (this.isNEAllowed(uf, city)) {
          const isCG = uf === "PB" && this.slugCity(city) === this.slugCity("Campina Grande");
          return [{ label: isCG ? "Frete Fixo - Campina Grande" : `Frete Fixo - ${city}`, price: this.FIXED_NE_PE_PRICE, obs: isCG ? "Condição especial para Campina Grande" : "Condição especial para capitais do Nordeste" }];
        }
        if (this.isSSCO(uf)) {
          const reg = ["PR","SC","RS"].includes(uf) ? "Sul" : (["SP","RJ","ES","MG"].includes(uf) ? "Sudeste" : "Centro-Oeste");
          return [{ label: `Frete Fixo ${reg}`, price: this.FIXED_SSCO_PRICE, obs: "Frete fixo para Sul/Sudeste/Centro-Oeste" }];
        }
      } catch (_) {}
      return [];
    },

    renderResults(list) {
      (list || [])
        .map(s => {
          let preco = parseFloat(String(s?.price ?? "").replace(",", "."));
          if (isNaN(preco)) preco = Infinity;
          const prazo = s?.delivery_time;
          return {
            nome: `${s?.company?.name || ""} ${(s?.name || "").replace(/\s*\(.*?\)/, "")}`.trim() || "Entrega",
            preco,
            precoFmt: isFinite(preco) ? `R$ ${preco.toFixed(2).replace(".", ",")}` : "-",
            prazoTxt: prazo ? `até ${prazo} dias úteis` : "",
            isGratis: preco <= 0
          };
        })
        .filter(s => isFinite(s.preco))
        .sort((a, b) => a.isGratis && !b.isGratis ? -1 : !a.isGratis && b.isGratis ? 1 : a.preco - b.preco)
        .forEach(s => renderFreteItem(s.nome, s.prazoTxt, s.precoFmt));
    },

    async calcular() {
      const cepDigits = getCepDigits();
      if (!cepDigits || cepDigits.length !== 8) { erroEl.textContent = "Preencha o CEP corretamente."; return; }
      if (!this.FROM_CEP) { erroEl.textContent = "CEP de origem não configurado."; return; }
      if (!this.getItemDimensions()) { erroEl.textContent = "Dimensões/peso do produto não encontrados."; return; }

      erroEl.textContent = "";
      container.innerHTML = "";
      setLoading(true);

      const [fixedItems, apiList] = await Promise.all([
        this.determineFixed(cepDigits).catch(() => []),
        this.requestCotacao(cepDigits).catch(() => [])
      ]);

      try {
        container.innerHTML = "";
        if (this.ENABLE_FREE) this.renderFreeShipping();
        if (this.ENABLE_PICKUP) this.renderPickup();
        fixedItems.forEach(it => this.renderFixedCard(it.label, it.price, it.obs));
        if (apiList.length) {
          this.renderResults(apiList);
        } else if (!container.querySelector(".frete-item") && API_URL) {
          erroEl.textContent = "Erro ao calcular frete. Tente novamente.";
        }
      } finally {
        setLoading(false);
      }
    }
  };

  // ─── Inicialização ─────────────────────────────────────────────────────────

  const platform = PLATFORM === "mandae" ? mandae : melhorEnvio;

  if (PLATFORM === "mandae" && mandae.refreshMode()) return;

  if (inputCep) {
    inputCep.addEventListener("input", e => { e.target.value = normalizeCepInput(e.target.value); });
    inputCep.addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); platform.calcular(); } });
  }

  if (botao) botao.addEventListener("click", () => platform.calcular());
});
